import React from "react";
import logo from './logo.svg'
import s from './Logo.module.scss'

const Logo = (props) => {
  return (
    <div className={s.logo}>
      <img src={logo} alt="logo" />
    </div>
  );
}

export default Logo;